const getAccessToken = state => state.activate.access_token;

export default getAccessToken;
